import React from 'react';

const Title = ({ text, style, testID = 'title' }) => {
  const myStyle = {
    // width: "136px",
    height: ' 32px',
    fontFamily: 'Roboto',
    fontSize: '24px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    margin: '31px auto 0 auto',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'center',
    //   color: var(--slate)
    ...style,
  };

  return (
    <h3 id="title-for-gerenic" style={myStyle} data-testid={testID}>
      {text}
    </h3>
  );
};
export default Title;
